<template>
  <div class="feld-label">
    <component :is="icon" v-if="icon" :size="16" class="feld-label__icon" />
    <span>{{ text }}</span>
    <span v-if="optional" class="feld-label__optional">(optional)</span>
    <span
      v-if="status"
      class="feld-label__status"
      :class="`feld-label__status--${status}`"
      v-b-tooltip.hover="{ customClass: 'restriktionen-sperrzeit-tooltip' }"
      :title="status === 'invalid' && statusTooltip ? statusTooltip : ''"
    >
      <CircleAlert v-if="status === 'invalid'" :size="14" />
      <Check v-else :size="14" />
    </span>
  </div>
</template>

<script>
import { CircleAlert, Check } from 'lucide-vue';

export default {
  name: 'FeldLabelComponent',
  components: {
    CircleAlert,
    Check,
  },
  props: {
    icon: { type: [Object, Function], default: null },
    text: { type: String, required: true },
    // Kennzeichnet das Feld als optional
    optional: { type: Boolean, default: false },
    // Validierungsstatus 'valid' oder 'invalid', null blendet das Status-Icon aus
    status: { type: String, default: null },
    // Tooltip-Text des Status-Icons, wird nur im Fehlerfall angezeigt
    statusTooltip: { type: String, default: null },
  },
};
</script>

<style scoped>
.feld-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  line-height: 15px;
  font-weight: 500;
  color: var(--text-body);
}

.feld-label__icon {
  color: var(--primary);
  flex-shrink: 0;
}

.feld-label__status {
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
}

.feld-label__status--invalid {
  color: var(--danger);
}

.feld-label__status--valid {
  color: var(--success);
}

.feld-label__optional {
  color: var(--text-muted);
  font-weight: 400;
  font-size: 12px;
}
</style>

<style>
.restriktionen-sperrzeit-tooltip {
  opacity: 1 !important;
}
</style>
